import { notContainsOnlySpaces } from "../../../utils";

export const validationFLFDeviceInput = (fieldValues, temp) => {
  if ("name" in fieldValues) {
    temp.name = notContainsOnlySpaces(fieldValues.name)
      ? ""
      : "This field is required.";
  }

  if ("code" in fieldValues) {
    temp.code = notContainsOnlySpaces(fieldValues.code)
      ? ""
      : "This field is required.";
  }

  if ("categoryId" in fieldValues) {
    temp.categoryId = notContainsOnlySpaces(fieldValues.categoryId)
      ? ""
      : "This field is required.";
  }

  if ("devTypeCode" in fieldValues) {
    if (fieldValues.devTypeCode === null) {
      temp.devTypeCode = "This field is required.";
    } else if (fieldValues.devTypeCode === "") {
      temp.devTypeCode = "This field is required.";
    } else {
      temp.devTypeCode = "";
    }
    if (isNaN(fieldValues.devTypeCode)) {
      temp.devTypeCode = "field must be a number";
    }
  }

  if ("devTypeStr" in fieldValues) {
    if (fieldValues.devTypeStr === null) {
      temp.devTypeStr = "This field is required.";
    } else {
      temp.devTypeStr = notContainsOnlySpaces(fieldValues.devTypeStr)
        ? ""
        : "This field is required.";
    }
  }

  if ("iotPartnerId" in fieldValues) {
    if (fieldValues.iotPartnerId === null) {
      temp.iotPartnerId = "This field is required.";
    } else {
      temp.iotPartnerId = notContainsOnlySpaces(fieldValues.iotPartnerId)
        ? ""
        : "This field is required.";
    }
  }

  if ("iconId" in fieldValues) {
    if (fieldValues.iconId === null) {
      temp.iconId = "This field is required.";
    } else {
      temp.iconId = notContainsOnlySpaces(fieldValues.iconId)
        ? ""
        : "This field is required.";
    }
  }

  return temp;
};

export const validationFLFIconInput = (fieldValues, temp) => {
  if ("deviceName" in fieldValues) {
    if (fieldValues.deviceName === null) {
      temp.deviceName = "This field is required.";
    } else {
      temp.deviceName = notContainsOnlySpaces(fieldValues.deviceName)
        ? ""
        : "This field is required.";
    }
  }

  if ("iconType" in fieldValues) {
    if (fieldValues.iconType === null) {
      temp.iconType = "This field is required.";
    } else {
      temp.iconType = notContainsOnlySpaces(fieldValues.iconType)
        ? ""
        : "This field is required.";
    }
  }

  return temp;
};

export const validationFLFCategoryInput = (fieldValues, temp) => {
  if ("name" in fieldValues) {
    temp.name = notContainsOnlySpaces(fieldValues.name)
      ? ""
      : "This field is required.";
  }

  if ("rogoDevTypeCode" in fieldValues) {
    if (fieldValues.rogoDevTypeCode === null) {
      temp.rogoDevTypeCode = "This field is required.";
    } else if (fieldValues.rogoDevTypeCode === "") {
      temp.rogoDevTypeCode = "This field is required.";
    } else {
      temp.rogoDevTypeCode = "";
    }
    if (isNaN(fieldValues.rogoDevTypeCode)) {
      temp.rogoDevTypeCode = "field must be a number";
    }
  }

  if ("rogoDevTypeStr" in fieldValues) {
    if (fieldValues.rogoDevTypeStr === null) {
      temp.rogoDevTypeStr = "This field is required.";
    } else {
      temp.rogoDevTypeStr = notContainsOnlySpaces(fieldValues.rogoDevTypeStr)
        ? ""
        : "This field is required.";
    }
  }

  return temp;
};

export const validationFLFIotPartnerInput = (fieldValues, temp) => {
  if ("partnerName" in fieldValues) {
    temp.partnerName = notContainsOnlySpaces(fieldValues.partnerName)
      ? ""
      : "This field is required.";
  }

  return temp;
};

export const validationFLFHomeIndexInput = (fieldValues, temp) => {
  if ("flfCategoryId" in fieldValues) {
    temp.flfCategoryId = notContainsOnlySpaces(fieldValues.flfCategoryId)
      ? ""
      : "This field is required.";
  }
  if ("flfQueryTypeId" in fieldValues) {
    temp.flfQueryTypeId = notContainsOnlySpaces(fieldValues.flfQueryTypeId)
      ? ""
      : "This field is required.";
  }

  return temp;
};

export const validationFLFPairingTypeInput = (fieldValues, temp) => {
  if ("name" in fieldValues) {
    temp.name = notContainsOnlySpaces(fieldValues.name)
      ? ""
      : "This field is required.";
  }
  if ("code" in fieldValues) {
    temp.code = notContainsOnlySpaces(fieldValues.code)
      ? ""
      : "This field is required.";
  }

  return temp;
};

export const validationFLFRogoDevSubTypeInput = (fieldValues, temp) => {
  if ("name" in fieldValues) {
    temp.name = notContainsOnlySpaces(fieldValues.name)
      ? ""
      : "This field is required.";
  }

  if ("devSubTypeCode" in fieldValues) {
    if (fieldValues.devSubTypeCode === null) {
      temp.devSubTypeCode = "This field is required.";
    } else if (fieldValues.devSubTypeCode === "") {
      temp.devSubTypeCode = "This field is required.";
    } else {
      temp.devSubTypeCode = "";
    }
    if (isNaN(fieldValues.devSubTypeCode)) {
      temp.devSubTypeCode = "field must be a number";
    }
  }

  if ("devSubTypeStr" in fieldValues) {
    if (fieldValues.devSubTypeStr === null) {
      temp.devSubTypeStr = "This field is required.";
    } else {
      temp.devSubTypeStr = notContainsOnlySpaces(fieldValues.devSubTypeStr)
        ? ""
        : "This field is required.";
    }
  }

  return temp;
};

export const validationFLFRogoDevTypeInput = (fieldValues, temp) => {
  if ("name" in fieldValues) {
    temp.name = notContainsOnlySpaces(fieldValues.name)
      ? ""
      : "This field is required.";
  }

  if ("devTypeCode" in fieldValues) {
    if (fieldValues.devTypeCode === null) {
      temp.devTypeCode = "This field is required.";
    } else if (fieldValues.devTypeCode === "") {
      temp.devTypeCode = "This field is required.";
    } else {
      temp.devTypeCode = "";
    }
    if (isNaN(fieldValues.devTypeCode)) {
      temp.devTypeCode = "field must be a number";
    }
  }

  if ("devTypeStr" in fieldValues) {
    if (fieldValues.devTypeStr === null) {
      temp.devTypeStr = "This field is required.";
    } else {
      temp.devTypeStr = notContainsOnlySpaces(fieldValues.devTypeStr)
        ? ""
        : "This field is required.";
    }
  }

  return temp;
};

export const validationFLFQueryTypeInput = (fieldValues, temp) => {
  if ("name" in fieldValues) {
    temp.name = notContainsOnlySpaces(fieldValues.name)
      ? ""
      : "This field is required.";
  }

  return temp;
};

export const validationFLFNotifyConfigInput = (fieldValues, temp) => {
  if ("name" in fieldValues) {
    temp.name = notContainsOnlySpaces(fieldValues.name)
      ? ""
      : "This field is required.";
  }

  return temp;
};

export const validationFLFContextInput = (fieldValues, temp) => {
  if ("name" in fieldValues) {
    temp.name = notContainsOnlySpaces(fieldValues.name)
      ? ""
      : "This field is required.";
  }

  if ("flfIconId" in fieldValues) {
    temp.flfIconId = notContainsOnlySpaces(fieldValues.flfIconId)
      ? ""
      : "This field is required.";
  }
  if ("type" in fieldValues) {
    temp.type = notContainsOnlySpaces(fieldValues.type)
      ? ""
      : "This field is required.";
  }

  if ("colors" in fieldValues) {
    temp.colors = notContainsOnlySpaces(fieldValues.colors)
      ? ""
      : "This field is required.";
  }

  return temp;
};
